import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  postImageManage,
  deletePhoto,
} from "../../../store/Action/imageAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./image.css";
export default function ManageImage() {
  const dispatch = useDispatch();
  const [image, setImage] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [deletes, setDelete] = useState(1);
  const itemsPerPage = 10; // Change this to the desired number of items per page

  // Logic to calculate total pages
  const queryParams = { page: currentPage, perPage: itemsPerPage };

  // Fetch categories and total count from API or any data source


  // Logic to handle pagination controls
  const nextPage = () => {
    if (image.length === itemsPerPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleDelete = async (categoryId) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      const response = await dispatch(deletePhoto(categoryId));
      if (response) {
        setDelete(response);
      }
    }
  };
  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await dispatch(postImageManage(queryParams));
        if (response) {
          setImage(response.data.photos); // Update with the correct field name from your API response
          // setTotalCount(response.data.totalCount);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchImage();
  }, [dispatch, deletes,]);
  // console.log(image,"asdfghj")
  // console.log(deletes)

  return (
    <div>
      <div className="card">
        <div className="card-header">Manage Images</div>
        <div className="card-body">
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Title</th>
                <th scope="col">Heading</th>
                <th scope="col">Image</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {image.map((item) => (
                <tr key={item._id}>
                  <td>
                    {item.title}
                  </td>
                  <td>{item.heading}</td>
                  <td>{item.thumbnail}</td>
                  {/* <td>{item.status}</td> */}
                  <td className="d-flex">
                    <Link to={`/editphoto/${item._id}`}>
                      <button
                        className="action-button"
                        //  onClick={() => handleEdit(item)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </Link>

                    <button
                      className="action-button"
                      onClick={() => handleDelete(item._id)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                  {/* Add action buttons here */}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="card-footer bg-transparent border-secondary d-flex justify-content-center">
          <div className="pagination">
          <button
            className="pagination-btn"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span className="current-page">{currentPage}</span>
          
          <button
            className="pagination-btn"
            onClick={nextPage}
            disabled={image.length < itemsPerPage}
          >
           { image.length < itemsPerPage  ? '' : 'Next'}
          </button>
        </div>
          </div>
        </div>
      </div>
    </div>
  );
}
